import React, { useRef } from "react";
import { Stage } from "@inlet/react-pixi";
import Viewport from "../Viewport";

const getSize = () => ({
  width: window.innerWidth,
  height: window.innerHeight,
});

const DrawingCanvas: React.FC = ({ children }) => {
  const ref = useRef<Stage>(null);

  return (
    <Stage
      ref={ref}
      options={{
        backgroundColor: 0x37425a,
        antialias: true,
        autoDensity: true,
      }}
      {...getSize()}
    >
      <Viewport>{children}</Viewport>
    </Stage>
  );
};

export default DrawingCanvas;
